<template>

	<div>

		<h5 class="Pdp-Carousel-heading" v-if="title">
			{{ this.title }}
		</h5>

		<carousel
			:navigationEnabled="true"
			:perPageCustom="[[300, 1], [500, 2], [768, 3], [1024, 4]]"
			:scrollPerPage="false"
			:class="['Pdp-Carousel', 'has-' + products.length]"
			:loop="true"
			navigationNextLabel=''
			navigationPrevLabel=''>

			<slide
				v-for="(tile, index) of products">

				<a :href="getTileLink(tile.sku_id, tile.sku_url)" class="tile" target="_blank">
					<img class="photo" :src="tile['flat_image_url']"/>
					<div class="brand" v-html="tile.brand"/>
					<div class="style" v-html="tile.style_name"/>
					<div class="price" v-html="`$${tile.price}`"/>
				</a>

			</slide>

		</carousel>

	</div>

</template>

<style></style>

<script>

import { Carousel, Slide } from 'vue-carousel';
import {array} from "../../../../../../wp-includes/js/dist/redux-routine";

export default {

	name: 'pdp-carousel',

	mixins: [],

	components: {
		Carousel,
		Slide
	},

	data() {

		return {
			pdpLink: 'https://www.stitchfix.com/path/to/pdp/',
			content: [],
			linkParams: '',
			'utm_source': 'mens-blog',
			'utm_campaign': 'blog-carousel',
		}

	},

	computed: {},

	props: {
		products: {
			type: array,
			default: () => [],
		},
		title:{
			type: String,
			default: 'Similar items curated for you',
		},
	},

	methods: {
		getTileLink(sku_id, sku_url) {
			this.linkParams.set('utm_content', sku_id)
			return sku_url +'?'+this.linkParams.toString()
		},

		buildBaseUrlParams() {
			this.linkParams = new URLSearchParams()
			this.linkParams.set('utm_campaign', this.utm_campaign)
			this.linkParams.set('utm_source', this.utm_source)
			this.linkParams.set('utm_medium', window.location.pathname)
		},


	},

	created() {
		this.buildBaseUrlParams()
	},

	mounted() {
		console.log("Mounted")
		console.log(this.products)
	},

	destroyed() {
	},

}

</script>
